import { tokens } from '@cub-com-br/theme';
import { Chip, Stack, SxProps, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';
import { IdentifiedDevelopment } from '~/api/types';
import { colors } from '~/theme';

const RowSx: SxProps = {
  'my': 1,
  'py': 2,
  'px': 3,
  'mx': 'auto',
  'backgroundColor': 'grey.100',
  'display': 'flex',
  'flexWrap': 'wrap',
  'justifyContent': 'space-between',
  'alignItems': 'center',
  'cursor': 'pointer',
  '&:hover': {
    backgroundColor: 'grey.200',
  },
  'maxWidth': '100%',
};

const LabelSx: SxProps = {
  textAlign: 'left',
  display: 'block',
  maxWidth: 'calc(100% - 50px)',
};

const ChipSx: SxProps = {
  'backgroundColor': colors.lightPurple,
  'color': tokens.white,
  'fontFamily': tokens.fontBody,
  'fontSize': 12,
  'textTransform': 'uppercase',
  'fontWeight': '700',
  'lineHeight': '150%',
  'height': '18px',
  '& .MuiChip-label': { px: '6.5px' },
};

const TitleSx: SxProps = {
  fontWeight: 'bold',
  wordWrap: 'break-word',
};

const CompanySx: SxProps = {
  color: 'grey.500',
  wordWrap: 'break-word',
};

/**
 * The row every development is listed as. Only the trailing element is left to
 * the screen rendering it.
 */
export const DevelopmentRow: FC<DevelopmentRowProps> = ({ development, onClick, trailing }) => {
  const { companyName, name, logo, isPayfac } = development;

  return (
    <Stack direction={'row'} sx={RowSx} onClick={onClick} gap={2}>
      <img src={logo} alt="Building Icon" style={{ width: 48, height: 48, flexShrink: 0 }} />
      <Stack sx={LabelSx} flex={1}>
        <Typography variant="body2" sx={CompanySx}>
          {companyName}
        </Typography>
        <Typography variant="body1" sx={TitleSx}>
          {name}
        </Typography>
      </Stack>
      {isPayfac && <Chip label="Imobiliária" sx={ChipSx} />}
      {trailing}
    </Stack>
  );
};

export interface DevelopmentRowProps {
  development: IdentifiedDevelopment;
  onClick?: () => void;
  /**
   * What closes the row, e.g. a chevron when picking a single development.
   */
  trailing: ReactNode;
}
